<ng-container *ngIf="session.loggedIn$ | async">
  <ngc-global-nav
    #globalNav
    [shopHeaderInput]="false"
    id="globalHeader"
  ></ngc-global-nav>
  <idp-login-modal-wrapper
    [fromApp]="'profileLandingPage'"
  ></idp-login-modal-wrapper>
  <idp-skymiles-page>
    <router-outlet></router-outlet>
  </idp-skymiles-page>
  <div class="footer-wrapper" id="globalFooter">
    <ngc-global-footer [globalNav]="globalNav"></ngc-global-footer>
  </div>
</ng-container>
